import React from 'react';
import { withTranslation } from 'react-i18next';
import { Checkbox, Tooltip } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { materialTableTheme } from '../utils/smartutils';

const SmartCheckbox = (props) => {
  const { tooltip } = props;
  return (
    <ThemeProvider theme={materialTableTheme}>
      <Tooltip title={tooltip}>
        <Checkbox {...props} />
      </Tooltip>
    </ThemeProvider>
  );
};

SmartCheckbox.propTypes = {
  tooltip: PropTypes.string,
};

SmartCheckbox.defaultProps = {
  tooltip: '',
};
export default withTranslation('common')(SmartCheckbox);
